import { Field, useField } from 'formik';
import { PropsWithChildren, useEffect, useState } from 'react';
import ErrorMessage from '../error/ErrorMessage';
import { RequiredAsterisk } from '../label/Label';

interface Props {
    name: string;
    required?: boolean;
    color?: 'gray' | 'black';
    initialChecked?: boolean;
    disabled?: boolean;
}
const CheckboxControl: React.FC<PropsWithChildren<Props>> = ({
    children,
    name,
    required,
    color = 'gray',
    initialChecked = false,
    disabled = false,
}) => {

    const [, { touched, error }, { setValue }] = useField(name)
    const [selfChecked, setSelfChecked] = useState(initialChecked)

    useEffect(() => {
        setValue(initialChecked)
    }, [initialChecked])

    const handleChange = event => {
        if (disabled) {
            return;
        }
        const nextValue = event.target.checked
        setSelfChecked(nextValue)
        setValue(nextValue)
    }

    return (
        <div className="flex flex-col">
            <label className="max-w-max">
                <Field type="checkbox" name={name} checked={selfChecked} disabled={disabled} onChange={handleChange} />
                <span className={`pl-2 text-sm ${color === 'gray' ? 'text-gray-650' : 'text-black'}`}>
                    {children}
                    <RequiredAsterisk required={required} />
                </span>
            </label>
            {error && touched &&
                (<ErrorMessage error={error} touched={touched} />)}
        </div>
    )
}

export default CheckboxControl;